interface Props {
  gapDays: number;
}

export function TimelineGap({ gapDays }: Props) {
  if (gapDays < 21) return null;
  const label =
    gapDays < 56
      ? `↕ ${Math.round(gapDays / 7)} Wochen Pause`
      : `↕ ${Math.round(gapDays / 30)} Monate Pause`;
  return (
    <div className="absolute -left-2 top-1/2 -translate-x-full -translate-y-1/2 whitespace-nowrap text-[10px] italic text-muted-foreground">
      {label}
    </div>
  );
}
